import React, { useState } from "react";
import "./style.css";
import { circleIcon } from "./../icons";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import {
  FormControl,
  InputLabel,
  NativeSelect,
  Tooltip,
} from "@mui/material";
import { valueLabelFormat } from "../utils/sliderFunctions";

const ComissionCalculator = ({
  setPrice,
  setDueDiligenceTimeline,
  dueDiligenceTimeline,
  price,
}) => {
  const formatSliderLabel = (value) => {
    if (value <= 1000000) return '< $1M';
    if (value >= 25000000) return '$25M+';
    return `$${value / 1000000}M`;
  };

  const timelineOptions = ['1 week', '2 weeks', '3-4 weeks'];

  const getTimelineNote = () => {
    switch (dueDiligenceTimeline) {
      case '1 week': return 'Priority delivery. 15% expediting fees.';
      case '2 weeks': return 'Priority delivery. 10% expediting fees.';
      case '3-4 weeks': return 'Standard delivery. No expediting fees.';
      default: return 'Standard delivery time. No expediting fees..';
    }
  };

  return (
    <aside className='pricing-controls-sidebar'>
      <div className='sidebar-body'>
        <div className='control-item'>
          <label className='control-label'>
            TARGET ENTERPRISE VALUE
            <Tooltip
              title='We use this to determine base pricing. Businesses below $1M are priced at the $1M minimum. For $25M+ businesses, pricing is shown as a starting point and may vary based on scope and complexity.'
              placement='right'
            >
              <span className="tooltip-trigger">{circleIcon}</span>
            </Tooltip>
          </label>
          <span className='sidebar-price-display'>{formatSliderLabel(price)}</span>
          <Slider
            aria-label='Business Purchase Price'
            defaultValue={2500000}
            step={100000}
            min={1000000}
            max={25000000}
            valueLabelDisplay='off'
            onChange={(e) => setPrice(e.target.value)}
            valueLabelFormat={valueLabelFormat}
            className='custom-slider'
          />
        </div>

        <div className='control-item'>
          <label className='control-label'>
            DUE DILIGENCE TIMELINE
            <Tooltip
              title='We deliver all reports within 3-4 weeks. If you require a quicker turnaround time, expediting fees are 15% for one week and 10% for two weeks, when possible. Your quote will be inclusive of any expediting fees.'
              placement='right'
            >
              <span className="tooltip-trigger">{circleIcon}</span>
            </Tooltip>
          </label>
          <div className='timeline-button-group'>
            {timelineOptions.map((option) => (
              <button
                key={option}
                className={`timeline-toggle-btn ${dueDiligenceTimeline === option ? 'active' : ''}`}
                onClick={() => setDueDiligenceTimeline(option)}
              >
                {option}
              </button>
            ))}
          </div>
          <div className='sidebar-timeline-note'>
            <i className='far fa-calendar-alt'></i>
            <span>{getTimelineNote()}</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default ComissionCalculator;
